import React from "react";
import { MDBBtn } from "mdbreact";
import { Link } from "react-router-dom";

import { scrollTop } from "../../../functions";

import "./OurPerformance.css";

export default () => {
  return (
    <div className="impact">
      <div className="impact-caption">
        <h1>NOSSA ATUAÇÃO</h1>
        <p>Como podemos ajudar.</p>
        <div className="impact-btns">
          <Link to="/nossa-atuacao/pesquisas" onClick={scrollTop}>
            <MDBBtn color="red">PESQUISAS</MDBBtn>
          </Link>
          <Link to="/nossa-atuacao/acoes" onClick={scrollTop}>
            <MDBBtn color="red">AÇÕES</MDBBtn>
          </Link>
        </div>
      </div>
    </div>
  );
};
